exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".mark-disabled{opacity:.4!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-0b9bf164!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/grid/DownloadComponent.vue
// module id = 841
// module chunks = 2